import SectionHeader from './SectionHeader.jsx';

const impacts = [
  { value: '\u20B9500+', sub: 'Crore', label: 'Projects Facilitated' },
  { value: '50+', sub: 'Acres', label: 'Land Optimized' },
  { value: '1000+', sub: 'Units', label: 'Designed & Delivered' },
  { value: '200+', sub: 'Investors', label: 'Engaged & Active' },
];

function ImpactSection() {
  return (
    <section
      className="section-full-wrap fade-up"
      style={{
        borderTop: '1px solid rgba(0,212,200,.06)',
        borderBottom: '1px solid rgba(0,212,200,.06)',
      }}
    >
      <div className="section-full-inner">
        <SectionHeader label="Results" title="Measured Impact" centered subtitle="" />

        <div className="impact-grid">
          {impacts.map((impact) => (
            <div key={impact.label} className="impact-item">
              <div className="impact-num">
                {impact.value.replace('+', '')}
                <span className="ac">+</span>
              </div>
              <div className="impact-sub">{impact.sub}</div>
              <div className="impact-label">{impact.label}</div>
            </div>
          ))}
        </div>

        <p className="impact-tagline">
          Where design decisions translate into measurable financial outcomes.
        </p>
      </div>
    </section>
  );
}

export default ImpactSection;
